ApplicationAdapter = require './application'

module.exports = App.BillingInfoAdapter = ApplicationAdapter.extend
  singularResource: true
